import React from 'react';
import { Link, useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import { getBlogBySlug } from '../data/blogs';

const BlogPost = () => {
  const { slug } = useParams();
  const blog = getBlogBySlug(slug);

  if (!blog) {
    return (
      <div className="px-6 pb-32 pt-40 text-center">
        <h1 className="font-serif text-6xl font-black uppercase italic">
          Story not found
        </h1>
        <Link
          to="/journal"
          className="mt-8 inline-block font-mono text-xs font-black uppercase underline"
        >
          Back to The Lost Boys
        </Link>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={blog.title}
        description={blog.excerpt}
        path={`/journal/${blog.slug}`}
        image={blog.image}
        article={{
          headline: blog.title,
          datePublished: blog.datePublished,
          image: blog.image,
        }}
      />
      <article className="mx-auto w-full max-w-5xl px-6 pb-32 pt-36">
        <Link
          to="/journal"
          className="font-mono text-xs font-black uppercase tracking-widest underline underline-offset-4"
        >
          ← Back to The Lost Boys
        </Link>

        <header className="mt-16 border-b-8 border-black pb-10">
          <p className="font-mono text-xs font-black uppercase tracking-[0.3em]">
            The Lost Boys / {blog.stamp} / {blog.issue}
          </p>
          <h1 className="mx-auto mt-8 w-full max-w-4xl break-words px-2 text-center font-serif text-[clamp(2.5rem,8vw,7rem)] font-black uppercase italic leading-[0.88] sm:px-0 lg:max-w-none lg:whitespace-nowrap lg:text-[clamp(2.5rem,6vw,5rem)] lg:tracking-[-0.04em]">
            {blog.title}
          </h1>
        </header>

        <div className="mt-12 flex max-h-[75vh] justify-center overflow-hidden bg-white">
          <img
            src={blog.image}
            alt={`Scene from Lost Boys Musical featured in ${blog.title}`}
            className="block h-auto max-h-[75vh] max-w-full object-contain"
          />
        </div>

        <div className="mx-auto mt-14 max-w-2xl">
          <p className="font-serif text-3xl font-bold leading-tight md:text-4xl">
            {blog.excerpt}
          </p>
          <div className="mt-12 space-y-6 font-mono text-sm leading-loose text-black/75">
            {(blog.content || []).map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </article>
    </>
  );
};

export default BlogPost;